import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { 
  GET_PURCHASES, 
  // GET_ADMIN_PROFILE,
  ADD_NEW_PURCHASE,
  UPDATE_PURCHASE,
  DELETE_PURCHASE
 } from "./actionTypes";
import {
  getPurchasesSuccess,
  getPurchasesFail,
  addPurchaseSuccess,
  addPurchaseFail,
  updatePurchaseSuccess,
  updatePurchaseFail,
  deletePurchaseSuccess,
  deletePurchaseFail,
  // getPurchaseProfileSuccess,
  // getPurchaseProfileFail,
} from "./actions";

//Include Both Helper File with needed methods
import { 
  getPurchases,
  // getPurchaseProfile,
  addNewPurchase,
  updatePurchase,
  deletePurchase,
} from "../../helpers/backend_helper";
import { showPopup } from "../popup/actions";

function* fetchPurchases({payload:{offset,page_size}}) {
  try {
    const response = yield call(getPurchases,{offset,page_size});
    yield put(getPurchasesSuccess(response));
  } catch (error) {
    yield put(getPurchasesFail(error));
        yield put(showPopup({title:error.response.data.message,error:true}));
  }
}

function* onUpdatePurchase({ payload: { purchase, history } }) {
  try {
   let response = yield call(updatePurchase, purchase);
  //  if(response.file_src || purchase.removeImage) purchase.image = response.file_src
    yield put(updatePurchaseSuccess(purchase));
        yield put(showPopup({title:response.message,success:true}));
    history && history.push("/purchases")
  } catch (error) {
    yield put(updatePurchaseFail(error));
        yield put(showPopup({title:error.response.data.message,error:true}));
  }
}

function* onDeletePurchase({ payload: purchase }) {

  try {
  let response =  yield call(deletePurchase, purchase);
    yield put(deletePurchaseSuccess(purchase));
        yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(deletePurchaseFail(error));
        yield put(showPopup({title:error.response.data.message,error:true}));
  }
}

function* onAddNewPurchase({ payload: { user,history }}) {
  try {
    let response = yield call(addNewPurchase, user)
    yield put(addPurchaseSuccess(response.data))
        yield put(showPopup({title:response.message,success:true}));
    history.push("/purchases")
  } catch (error) {
    yield put(addPurchaseFail(error))
        yield put(showPopup({title:error.response.data.message,error:true}));
  }
}


// function* fetchPurchaseProfile() {
//   try {
//     const response = yield call(getPurchaseProfile);
//     yield put(getPurchaseProfileSuccess(response));
//   } catch (error) {
//     yield put(getPurchaseProfileFail(error));
//   }
// }

function* purchasesSaga() {
  yield takeEvery(GET_PURCHASES, fetchPurchases);
  yield takeEvery(ADD_NEW_PURCHASE, onAddNewPurchase);
  yield takeEvery(UPDATE_PURCHASE, onUpdatePurchase);
  yield takeEvery(DELETE_PURCHASE, onDeletePurchase);
  // yield takeEvery(GET_ADMIN_PROFILE, fetchPurchaseProfile);
}

export default purchasesSaga;
